























import Vue, { PropType } from 'vue';

import {
  Brand,
  Booth,
} from 'mostra';

export default Vue.extend({
  name: 'GBoothTop',
  props: {
    owner: {
      type: String as PropType<string>,
      required: true,
    },
    booths: {
      type: Array as PropType<Booth[]>,
      default: () => [],
    },
    brands: {
      type: Array as PropType<Brand[]>,
      default: () => [],
    },
  },
  // methods: {
  //   onClickEdit(id: string) {
  //     this.$emit('onClickEdit', id);
  //   },
  // },
});
